module.exports = __webpack_public_path__ + "img/hire.ffa37d5e.jpg";